import { PageModule } from '../../utils/page.module';
import { Param, readUrlParameter } from '../../utils/url.utils';
import { getHtmlFromUrl } from '../../api/general-api';
import { createHtmlElementFromString } from '../../utils/html.utils';
import { header } from '../header/header.module';

/**
 * Creates a custom page for the e-catalog.
 */
export class ECatalogCustom extends PageModule {
  /**
   * Selector that is rendered in this view.
   */
  componentSelector = '.e-catalog-custom';

  /**
   * Markup for the custom page
   */
  template = '<div class="e-catalog-custom"></div>';

  /**
   * Markup for the loading indicators
   */
  loadingIndicatorMarkup = `<div class="indicators indicators--loading">
    <span class="indicator indicator--active"></span>
    <span class="indicator indicator--active"></span>
    <span class="indicator indicator--active"></span>
  </div>`;

  /**
   * Setup the component with translations
   * @param translations The translations to initialize
   */
  constructor(translations: { [key: string]: string }) {
    super();
    this.translations = translations;
  }

  /**
   * Create the custom page
   */
  renderView(): void {
    // Hide the headers shadow before user scrolled
    header.setHideShadowBeforeScrolled(true);

    // set the page title
    document.title = this.translations.headerTitle;

    const url = readUrlParameter(Param.CUSTOM_URL);
    // Show loading indicator while content is loaded
    this.pageComponent.appendChild(createHtmlElementFromString(this.loadingIndicatorMarkup));
    getHtmlFromUrl(url).then((html) => {
      // Remove loading indicator
      this.pageComponent.firstElementChild.remove();
      // Render content
      if (html.length > 0) {
        const div = document.createElement('div');
        div.innerHTML = html;
        this.pageComponent.appendChild(div);
      }
    });
  }
}
